import React, { useState } from 'react';
import { connect } from 'react-redux';

import amplitude from 'amplitude-js';
import { toggleChat } from 'apps/auth/actions/chatAction';
import { Button } from 'apps/auth/components/common/Button/Button';
import { DocsList } from 'apps/auth/components/common/components/DocsList/DocsList';
import { DocsListItem } from 'apps/auth/components/common/components/DocsList/DocsListItem';
import { DocsIllustration, DocsTable, DocsTd, DocsTr } from 'apps/auth/components/common/components/DocsList/styles';
import { DangerouslyHtml } from 'apps/auth/components/common/DangerouslyHtml/DangerouslyHtml';
import { CommonPage } from 'apps/auth/components/common/Layout/CommonPage/CommonPage';
import { FixedBottomPanel } from 'apps/auth/components/common/Layout/FixedBottomPanel/FixedBottomPanel';
import { InfoPage } from 'apps/auth/components/common/Layout/InfoPage/InfoPage';
import BasePage from 'apps/auth/components/utils/BasePage';
import {
    AF_CHAT_BOT_BUTTON_CLICKED_WITH_SOURCE_OF_PAYMENT,
    AF_PROMO_PAYMENT_METHOD_VERIF_CONTINUE_CLICKED,
} from 'apps/auth/constants/amplitude/AmplitudeEvents';
import { SCENARIO_ID } from 'apps/auth/constants/amplitude/AmplitudeParamName';
import { FRAUD_SOURCE_OF_INCOME_INSTRUCTIONS, FRAUD_SOURCE_OF_INCOME_INTRO } from 'apps/auth/constants/ComponentNames';
import { AUTH_SEND_MAIN_LINK, URL_IMAGES_I } from 'apps/auth/constants/UrlConstants';
import { useExtra, usePageMessages } from 'apps/auth/hooks/selectors';

const AntiFraudSourceOfIncomePage = (props) => {
    const messages = usePageMessages();
    const { fraudScenarioId } = useExtra();
    const [currentScreen, setCurrentScreen] = useState(FRAUD_SOURCE_OF_INCOME_INTRO);

    const onContinueIntro = () => {
        amplitude.getInstance().logEvent(AF_PROMO_PAYMENT_METHOD_VERIF_CONTINUE_CLICKED, { [SCENARIO_ID]: fraudScenarioId });
        setCurrentScreen(FRAUD_SOURCE_OF_INCOME_INSTRUCTIONS);
    };

    const componentMap = {
        [FRAUD_SOURCE_OF_INCOME_INTRO]: (
            <CommonPage>
                <InfoPage
                    iconName="id-card-80"
                    iconColor="primary"
                    headerText={<DangerouslyHtml dangerouslyHtml={messages.introHeaderTitle} />}
                    secondaryText={<DangerouslyHtml dangerouslyHtml={messages.introText} />}
                    primaryButtonCaption={messages.continueButton}
                    topButtonCaption={messages.notNowButton}
                    topButtonType="link"
                    topButtonLink={AUTH_SEND_MAIN_LINK}
                    primaryButtonOnClick={onContinueIntro}
                />
            </CommonPage>
        ),
        [FRAUD_SOURCE_OF_INCOME_INSTRUCTIONS]: (
            <CommonPage backUrl={AUTH_SEND_MAIN_LINK} leftCloseIcon>
                <DocsList>
                    <DocsListItem title={messages.incomeLimitsTitle}>
                        <DocsTable>
                            <DocsTr>
                                <DocsTd>
                                    <DocsIllustration>
                                        <img src={`${URL_IMAGES_I}/kyc-bank-doc-plain.svg`} alt="illustration" />
                                    </DocsIllustration>
                                </DocsTd>
                            </DocsTr>
                            <DocsTr>
                                <DocsTd>
                                    <DangerouslyHtml dangerouslyHtml={messages.amlLimitIncomeBlock} type={'text'} />
                                </DocsTd>
                            </DocsTr>
                        </DocsTable>
                    </DocsListItem>
                    <DocsListItem title={messages.chatLimitsTitle}>
                        <p>{messages.chatLimitsPreview}</p>
                    </DocsListItem>
                    <DocsListItem title={messages.waitLimitsTitle}>
                        <p>{messages.waitLimitsPreview}</p>
                    </DocsListItem>
                </DocsList>
                <FixedBottomPanel isRightAligned>
                    <Button
                        caption={messages.chatButton}
                        type={'link'}
                        onClick={() => {
                            amplitude.getInstance().logEvent(AF_CHAT_BOT_BUTTON_CLICKED_WITH_SOURCE_OF_PAYMENT, { [SCENARIO_ID]: fraudScenarioId });
                            props.toggleChat(true);
                        }}
                    />
                </FixedBottomPanel>
            </CommonPage>
        ),
    };
    return <>{currentScreen ? componentMap[currentScreen] : null}</>;
};

export default connect(null, {
    toggleChat,
})(BasePage(AntiFraudSourceOfIncomePage));
